/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdateExtensionTelemetryConsentRequestStateEnum = {
    granted: 'granted',
    refused: 'refused'
};
/**
 * Check if a given object implements the UpdateExtensionTelemetryConsentRequest interface.
 */
export function instanceOfUpdateExtensionTelemetryConsentRequest(value) {
    if (!('schemaVersion' in value) || value['schemaVersion'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
export function UpdateExtensionTelemetryConsentRequestFromJSON(json) {
    return UpdateExtensionTelemetryConsentRequestFromJSONTyped(json, false);
}
export function UpdateExtensionTelemetryConsentRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clauseVersion': json['clauseVersion'] == null ? undefined : json['clauseVersion'],
        'schemaVersion': json['schemaVersion'],
        'state': json['state'],
    };
}
export function UpdateExtensionTelemetryConsentRequestToJSON(json) {
    return UpdateExtensionTelemetryConsentRequestToJSONTyped(json, false);
}
export function UpdateExtensionTelemetryConsentRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clauseVersion': value['clauseVersion'],
        'schemaVersion': value['schemaVersion'],
        'state': value['state'],
    };
}
